export function correctFormName(name: string) {
  return name.replaceAll(' ', '_');
}
